<template>
  <div class="page">
    <div class="content"  >
      <v-banner :listImg="banners" @imgClick="bannerClick"/>
      <v-foxconn v-if='isFoxconn' titleText='首次充值满5元,送5元' />
      <v-charge  :text="balance" @charge="recharge"/>
      <div class="tiles">
        <v-tile :src='billImg' content="账单" @click="$router.push('month-bill')"></v-tile>
        <v-tile :src='orderingImg' content="订餐" @click="$router.push('period-list')"></v-tile>
        <v-tile :src='takemealImg' content="取餐" @click="$router.push('my-qr-code')"></v-tile>
      </div>
      
      <!-- <div class="img-wrapper">
        <img src="http://img1.gtimg.com/news/pics/hv1/150/79/2043/132866370.jpg"/>
      </div> -->
    </div>
    <v-tab class="tab-class" style="background:white;" :active1=true :active2=false @click="tabClick"></v-tab>
    <v-qrcode-tip v-if='qrcodeShow' class="qrcode-class" @click="qrcodeClick"></v-qrcode-tip>
    <van-dialog
      v-model="show"
      title="长按二维码充值"
      confirm-button-text="关闭">
      <div id="qrcode" style="display: flex;justify-content:center; padding:20px 0;" ref="qrcode"></div>
    </van-dialog>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { GET_HOMEPAGE } from '../store/homepage'
  import mixin from './mixin'
  import billImg from '../assets/img/bill@2x.png'
  import orderingImg from '../assets/img/ordering@2x.png'
  import takemealImg from '../assets/img/takemeal@2x.png'
  import api from '../api'
  import QRCode from 'qrcodejs2'  // 引入qrcode
  export default {
    mixins: [mixin],
    data () {
      return {
        billImg,
        orderingImg,
        takemealImg,
        balance: '-',
        link:'',
        show:false,
        hasCode:false,
        qrcodeShow: false,
        param: {
          companyName: ''
        },
        leavePage: {
          redirect: true,
          pass: ['charge', 'month-bill', 'main', 'period-list', 'my-qr-code', 'personal-center', 'order-list'],
          to: 'main'
        }
      }
    },
    computed: {
      ...mapState({ user: state => state.user, banners: state => state.homepage.banners }),
      buttonDiasbled: function () {
        return !this.validateAll(this.param).valid
      },
      isFoxconn () {
        return this.user.companyId.toString() === '24' & this.formatDate(Date.now()) === '2017-11-09'
      }
    },
    methods: {
      ...mapActions([GET_HOMEPAGE]),
      recharge () {
      if (!this.user.phoneNumber) {
        this.$router.push("/login");
        return;
      }
      if (!this.user.paymentCode) {
        this.showToast("暂无缴费项目编号，请联系相关银行");
        return;
      }
      this.show = true
      this.qrcode(`https://enjoy.abchina.com/jf-web/epayItem?code=${
        this.user.paymentCode
      }&userInput=%7B%22input1%22%3A%22${
        this.user.phoneNumber
      }%22%2C%22input2%22%3A%22100%22%7D&showBill=0`)

      // window.location.href = `https://enjoy.abchina.com/jf-web/epayItem?code=${
      //   this.user.paymentCode
      // }&userInput=%7B%22input1%22%3A%22${
      //   this.user.phoneNumber
      // }%22%2C%22input2%22%3A%22100%22%7D&showBill=0`
      // if (this.abcRechargeBonus.status) {
      //   this.showConfirm = true
      // } else {
      //   this.confirm()
      // }
    },
      bannerClick (e) {
        let url = this.banners[e].url
        if (url && url.length > 0) {
          location.href = url
        }
      },
      tabClick (type) {
        if (type === 'my') {
          this.$router.push('personal-center')
        }
      },
      qrcodeClick () {
        this.qrcodeShow = false
        sessionStorage.setItem('qrcode_notshow', 1)
      },
      subscribestatus () {
        if (this.user.openId) {
          api.subscribestatus(this.user).then((data) => {
            if (data.subscribed) {
              // 用户已经关注过 不再显示
              sessionStorage.setItem('qrcode_notshow', 1)
              this.qrcodeShow = false
            } else {
              // 用户没有关注过 显示
              sessionStorage.setItem('qrcode_notshow', 0)
              this.qrcodeShow = true
            }
          }, data => {
            sessionStorage.setItem('qrcode_notshow', 0)
            this.qrcodeShow = true
            this.showToast(data)
          })
        }
      },
      qrcode (url) {
        if(!this.hasCode){
          setTimeout(()=>{new QRCode('qrcode', {
            width: 150,
            height: 150,        // 高度
            text:  url,   // 二维码内容
          })},0)
        }
        this.hasCode = true

      },
    },
    created () {
      let path = window.localStorage.getItem('path-after-login')
      if (path) {
        this.$router.push({ path })
        window.localStorage.setItem('path-after-login', null)
      }
    },
    mounted () {
      this.GET_HOMEPAGE(this.user).then((data) => {
      }, data => {
        this.showToast(data, 'cancel')
      })
      // sessionStorage.removeItem('qrcode_notshow')
      let notShow = sessionStorage.getItem('qrcode_notshow')
      if (notShow === '0' || notShow === null) {
        this.subscribestatus()
      } else {
        this.qrcodeShow = false
      }
      this.setTitle('我的菜')
      api.getBalance(this.user).then((data) => {
        this.balance = this.formatPrice(data.totalBalance,this.user.companyId);
      }, data => {
        this.showToast(data)
      })
      

    },
    activated () {
      
    }
  }
</script>
<style lang="stylus" scoped>
@import '../css/var'
$tab-height = pt(100)

.page
  min-height 100%
  background #F3F3F3

.content
  width 100%
  min-height  "calc(100vh - %s)" % $tab-height
  height 100%
  padding-bottom $tab-height+8pt
  background #F3F3F3
  .tiles
    padding-left $normal-left-padding
    padding-right $normal-right-padding
    margin-top pt(45)
    margin-bottom pt(45)
    width 100%
    display flex
    justify-content space-between
    > *
      flex 0 1 auto
  .img-wrapper
    height pt(240) 
    center-with-padding()
    object-fit cover
    border 0
    img
      object-fit cover
      height 100%
      width 100%
      border-radius pt(10)

.tab-class
  position fixed
  bottom 0
  left 0
  right 0
  height $tab-height
  box-shadow 0 0 0.5em #CCD5D8

.qrcode-class
  position fixed
  bottom 0
  left 0
  right 0
</style>



// WEBPACK FOOTER //
// main.vue?9714a418